let standAndFun = {
    title: "",
    content: "about.standAndFun",
    imagePath: "https://i.imgur.com/69J0NWF.jpg"
}
export default standAndFun;